<template lang="pug">
.report-charges
  h1 水电充值报表

  month-select(:start.sync='date_start', :end.sync='date_end', mode='years')

  table.ui.celled.structured.table.fixed.olive
    thead
      tr
        th.center.aligned(rowspan='2') 楼层
        th.center.aligned(colspan='2') 电
        th.center.aligned(colspan='2') 冷水
        th.center.aligned(colspan='2') 热水
        th.center.aligned(colspan='2') 厨房
        th.center.aligned.positive(rowspan='2') 汇总
      tr
        th.center.aligned 千瓦时
        th.center.aligned 金额
        th.center.aligned 吨
        th.center.aligned 金额
        th.center.aligned 吨
        th.center.aligned 金额
        th.center.aligned 吨
        th.center.aligned 金额
    tbody
      tr(v-for='(row, irow) in data', :class='{summary: irow === data.length - 1}')
        td.right.aligned(v-for='(value, icol) in row', :class='{positive: icol === 9}') {{value}}
</template>

<script>
import MonthSelect from './MonthSelect.vue'

export default {
  name: 'report-charges',
  components: { MonthSelect },
  data() {
    return {
      date_start: this.$moment(),
      date_end: this.$moment(),
    }
  },
  mounted() {
    this.$store.dispatch('load_charges')
  },
  computed: {
    data() {
      const result = {}
      for (const charge of this.filtered_charges) {
        if (charge.utilities) {
          const room = this.$store.getters.room_by_id(charge._room)
          if (room && room.category) {
            const floor = room.category
            if (!result[floor]) {
              result[floor] = (new Array(10)).fill(0)
              result[floor][0] = floor
            }

            const electricity = charge.utilities.filter(u => u.type === 'electricity')[0]
            const water = charge.utilities.filter(u => u.type === 'water')[0]
            const hot_water = charge.utilities.filter(u => u.type === 'hot_water')[0]
            const kitchen = charge.utilities.filter(u => u.type === 'kitchen')[0]

            if (electricity) {
              result[floor][1] += electricity.quantity || 0
              result[floor][2] += electricity.quantity * electricity.unit_price || 0
            }

            if (water) {
              result[floor][3] += water.quantity || 0
              result[floor][4] += water.quantity * water.unit_price || 0
            }

            if (hot_water) {
              result[floor][5] += hot_water.quantity || 0
              result[floor][6] += hot_water.quantity * hot_water.unit_price || 0
            }

            if (kitchen) {
              result[floor][7] += kitchen.quantity || 0
              result[floor][8] += kitchen.quantity * kitchen.unit_price || 0
            }
          }
        }
      }

      const formate_row = (row) => ([
        row[0],
        this.$formatters.money(row[1]),
        this.$formatters.money(row[2]),
        this.$formatters.money(row[3]),
        this.$formatters.money(row[4]),
        this.$formatters.money(row[5]),
        this.$formatters.money(row[6]),
        this.$formatters.money(row[7]),
        this.$formatters.money(row[8]),
        this.$formatters.money(row[2] + row[4] + row[6] + row[8]),
      ])
      const formatted = []
      const summary = (new Array(10)).fill(0)
      for (const key of Object.keys(result).sort()) {
        const row = result[key]
        for (let i = 1; i < 10; i++)
          summary[i] += row[i]
        formatted.push(formate_row(row))
      }
      summary[0] = '合计'
      formatted.push(formate_row(summary))
      return formatted
    },
    charges() {
      return this.$store.state.summary.charges || []
    },
    filtered_charges() {
      return this.charges.filter(c => {
        const time = this.$moment(c.time_created)
        return time < this.date_end && time >= this.date_start
      })
    },
  },
}
</script>



// WEBPACK FOOTER //
// Charges.vue?60548964